var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitadelIdFvtaoEtk0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 544.4 65",
    style: {
      enableBackground: "new 0 0 544.4 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#08225A;}\n ")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 65,
    width: 544.4,
    x: -343.4,
    y: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 45.5,
    className: "st0",
    width: 124.5,
    height: 17.9
  }), /*#__PURE__*/React.createElement("rect", {
    y: 1.2,
    className: "st0",
    width: 24.9,
    height: 17.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.8,
    y: 1.2,
    className: "st0",
    width: 24.9,
    height: 17.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.6,
    y: 1.2,
    className: "st0",
    width: 24.9,
    height: 17.9
  }), /*#__PURE__*/React.createElement("rect", {
    y: 23.3,
    className: "st0",
    width: 60.1,
    height: 17.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.4,
    y: 23.3,
    className: "st0",
    width: 60.1,
    height: 17.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.7,61.3c8.1-0.3,10-1.8,10-5.2V8.8c0-3.4-1.8-5-10-5.4V1.5h28.8v2c-8.1,0.3-10,1.9-10,5.4v47.2 c0,3.4,1.8,5,10,5.2v2.1h-28.8V61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.9,61.3c8.1-0.3,10.6-1.8,10.6-5.2V4h-4.6c-7.7,0-11.6,0-16.1,11.3l-2-0.2l0.5-13.5h52.8l0.5,13.5 l-2,0.2C302.6,4.8,298.6,4,290.7,4H286v52.1c0,3.4,2.5,5,10.6,5.2v2.1h-29.8L266.9,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431,61.3c8-0.3,10-1.8,10-5.2V8.8c0-3.4-2-5-10-5.4V1.5h50.3l0.3,13.5h-2c-3.8-11-7-11.1-17.4-11.1h-12.6 v25.9h5.6c7.2,0,10.4-1.7,12.8-11.4h1.8v25.4h-1.8c-2.4-9.8-5.6-11.3-12.8-11.3h-5.6v27.8h12.5c12.3,0,16.2,0.3,20.4-11.4h2 L484,63.3h-53V61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.9,61.3c7.9-0.3,10-1.8,10-5.2V8.8c0-3.4-2-5-10-5.4V1.5H522v2c-8.1,0.3-9.5,1.8-9.5,5.4v51.5h9.2 c12.1,0,16.2-3.6,20.7-17h1.9l-0.7,20h-49.7V61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M393.1,1.5h-24.8v2.1c6.6,0.4,8.4,2.1,8.4,5.2v47.3c0,3.2-1.8,4.7-8.4,5.1v2.2H394c23,0,33-15.5,33-32.1 C427,14,415.5,1.5,393.1,1.5z M392.2,60.4h-6.7V4h6.7c16.6,0,24.9,7.2,24.9,27.9S411.7,60.4,392.2,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.8,53L337.5,0h-3.1l-19,47.6c-3.7,9-6.2,12.4-12.3,13.9v1.9h20.6v-1.9c-8.1-1.4-9-3.4-5.2-13.4l3.2-8.3 h21.3l4.9,14.3c1.8,5.1,0.5,7-7.8,7.4v1.9h25.8v-2.2C360.2,60.2,358.8,58.2,356.8,53z M322.6,37.3l10.1-25.9h0.5l9,25.9H322.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.2,2.5c-10.8,0-20.9,9.5-20.9,30.4c0,19.8,12.1,28.1,22.6,28.1c3.2,0,6.3-0.8,9.2-2.4 c2.9-1.5,5.4-3.7,7.3-6.4c1.3-1.9,2.3-3.9,3-6.1l2,0.6c-1,3.3-2.5,6.5-4.5,9.3c-2,2.7-4.6,4.8-7.6,6.3c-0.9,0.4-1.8,0.8-2.7,1.1 c-1,0.4-2,0.7-3.1,0.9c-1.9,0.4-3.9,0.7-5.9,0.7c-17.7,0-30.1-12.7-30.1-31.8S173.3,0,191.2,0c5.4-0.1,10.8,1.3,15.5,3.8h3.2 l0.6,6l1.3,10.4h-1.9C205.8,8.9,199.4,2.5,190.2,2.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitadelIdFvtaoEtk0);
export default __webpack_public_path__ + "static/media/Citadel_idFvtaoETK_0.36d6ec91cef03e9c14dbd95f26eb6991.svg";
export { ForwardRef as ReactComponent };